import hash from "object-hash";
import API from "../../API";

const PAGE_SIZE_FOR_PACKAGES = 500;

const GEOFENCE_CACHE_KEY = "GEOFENCE_PACKAGES";

export default async (params = {}, forceUpdate = false) => {
  const CACHE_KEY = `${GEOFENCE_CACHE_KEY}-${hash(params)}`;

  let packages;

  if (!forceUpdate) {
    packages = sessionStorage.getItem(CACHE_KEY);
    if (packages) return JSON.parse(packages);
  }

  params.page_size = PAGE_SIZE_FOR_PACKAGES;
  const geoPacks = await API.geofencePackages.list(params);
  const mapIds = [undefined, ...new Set(geoPacks.filter((gp) => gp.map_id).map((gp) => gp.map_id))];
  const ruleIds = [
    undefined,
    ...new Set(geoPacks.filter((gp) => gp.rules_id).map((gp) => gp.rules_id)),
  ];

  const ret = [geoPacks, mapIds, ruleIds];
  sessionStorage.setItem(CACHE_KEY, JSON.stringify(ret));

  return ret;
};
